import { Controller } from '@hotwired/stimulus'

// セッション内でのモーダル表示回数を保持する sessionStorage キー。
// sessionStorage はタブ（ブラウジングコンテキスト）を閉じると破棄され、同一タブ内の
// ページ遷移では保持されるため、セッション単位での表示回数制限に利用できる (#13088)。
const COUNTER_STORAGE_KEY = 'restraintModalShowedCounter'
const MAX_SHOW_COUNT = 2

export default class extends Controller {
  static targets = ['modal']

  connect () {
    // ページを跨いでも同セッション内なら表示回数を引き継ぐため sessionStorage から復元する。
    // 初回アクセス時や取得に失敗した場合（プライベートブラウズ厳格モード等）は 0 から開始する。
    this.modalShowedCounter = readStoredCounter()
    setTimeout(() => { this.showModal() }, this.firstTime)
  }

  get className () {
    return this.element.dataset.classname
  }

  get firstTime () {
    return this.element.dataset.firsttime
  }

  get secondTime () {
    return this.element.dataset.secondtime
  }

  get restartTime () {
    return this.element.dataset.restarttime
  }

  showModal () {
    if (this.hasModalTarget) {
      if (this.modalShowedCounter < MAX_SHOW_COUNT) {
        if (!document.querySelector('[class*="modal-open"]')) {
          this.modalTarget.classList.add(`${this.className}::visible`)
          this.modalShowedCounter++
          writeStoredCounter(this.modalShowedCounter)
        }
      }
    }
  }

  close () {
    if (this.hasModalTarget) {
      this.modalTarget.classList.remove(`${this.className}::visible`)
      setTimeout(() => { this.showModal() }, this.secondTime)
    }
  }

  setRestraintModal () {
    if (this.hasModalTarget) {
      // showModal と同じく上限到達済み（counter >= MAX_SHOW_COUNT）なら再表示を予約しない。
      if (this.modalShowedCounter < MAX_SHOW_COUNT) {
        if (!document.querySelector('[class*="modal-open"]')) {
          setTimeout(() => { this.showModal() }, this.restartTime)
        }
      }
    }
  }
}

// sessionStorage が無効な環境（プライベートブラウズ厳格モード等）でも
// 例外で connect 全体を落とさないよう try/catch でフォールバックする。
// 未保存・例外・不正値（負数や非整数など改竄・破損された値）はいずれも 0 として開始する。
function readStoredCounter () {
  try {
    const raw = window.sessionStorage.getItem(COUNTER_STORAGE_KEY)
    if (raw === null) return 0
    const parsed = Number(raw)
    return Number.isInteger(parsed) && parsed >= 0 ? parsed : 0
  } catch {
    return 0
  }
}

function writeStoredCounter (value) {
  try {
    window.sessionStorage.setItem(COUNTER_STORAGE_KEY, String(value))
  } catch {
    // sessionStorage 無効時は無視（次回 connect でも 0 として開始される）。
  }
}
